<template>
  <div class="main-map">
    <div class="button-action">
      <CommonSelect
          v-if="map"
          class="list-station"
          v-model="selectedStationId"
          :items="chargingStations"
          key-field="id"
          value-field="id"
          label-field="name"
          :placeholder="$t('label.select_station')"
          @change="filterStation"
      />
      <CommonButton v-if="map" @click="fullScreenMap">{{ $t("label.full_screen_map") }}</CommonButton>
    </div>
    <GmapMap
        :center="mapCenter"
        :zoom="14"
        map-type-id="hybrid"
        style="width: 100%; height: 500px"
        ref="mapRef"
    >
      <GmapMarker
          v-for="station in chargingStations"
          :key="station.id"
          :position="{ lat: station.lat, lng: station.lng }"
          @click="selectStation(station)"
          :icon="{
    url: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEWZmZm6urv+AAAAAXRSTlMAQObYZgAAAApJREFUCNdjYAAAAAIAAeIhvDMAAAAASUVORK5CYII=',
    scaledSize: { width: 1, height: 1 }
  }"
      />
      <CustomOverlay
          v-for="station in chargingStations"
          v-if="map"
          :map="map"
          :position="{ lat: station.lat, lng: station.lng }"
          :visible=true
      >
        <div class="bb-div">
          <span class="cp-loc-name" @click="goToDetail(station?.id)">{{ station.name }}</span>
          <div class="charger-info" :class="{'charger-info-loading': isLoading}"
               @click="goToDetail(station?.id)">
            <span v-if="!isLoading">{{ station.noOfAvailableConnectors }} / {{
                station.noOfUnAvailableConnectors
              }}</span>
            <loading :width=22 :height=22 color="white" :active="isLoading" :is-full-page="false" loader="dots"/>
          </div>
        </div>
      </CustomOverlay>
    </GmapMap>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CustomOverlay from "@/views/custom/map/CustomOverlay.vue";
import CommonSelect from "@/components/selects/CommonSelect.vue";
import CommonButton from "@/components/buttons/CommonButton.vue";

export default {
  name: 'ChargingStationMap',
  components: {CustomOverlay, Loading, CommonSelect, CommonButton},
  data() {
    return {
      showTooltip: true,
      map: null,
      mapCenter: {lat: 22.352914460218937, lng: 114.09579733299391},
      chargingStations: [],
      selectedStation: null,
      isLoading: true,
      cpUsage: {
        noOfChargingConnectors: 0,
        noOfAvailableConnectors: 0,
        noOfUnAvailableConnectors: 0
      },
      selectedStationId: null,
    }
  },
  mounted() {
    this.$refs.mapRef.$mapPromise.then((map) => {
      this.map = map;
    });
    this.fetchChargingStations()
  },
  methods: {
    goToDetail(id) {
      this.$router.push(`/cp_locs/floor_plan?station=${id}`);
    },
    async selectStation(station) {
      this.isLoading = true
      try {
        station.noOfChargingConnectors = 0;
        station.noOfAvailableConnectors = 0;
        station.noOfUnAvailableConnectors = 0;
        this.selectedStation = station;
        const loc = await this.$axios.get(`/cp_locs/${station.id}/usage`);
        if (loc.data) {
          station.noOfChargingConnectors = loc.data.noOfChargingConnectors;
          station.noOfAvailableConnectors = loc.data.noOfAvailableConnectors;
          station.noOfUnAvailableConnectors = loc.data.noOfUnAvailableConnectors;
          this.selectedStation = station;
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false;
        console.error(e)
      }
    },
    async fetchChargingStations() {
      try {
        const res = await this.$axios.get('/cp_locs');
        this.chargingStations = res.data?.response?.dataset?.filter(info => !!info['gps_lat'] && !!info['gps_lng']).map(info => {
          return {id: info['loc_id'], name: info['address'], lat: Number(info['gps_lat']), lng: Number(info['gps_lng'])}
        });
        if (this.chargingStations && this.chargingStations.length > 0) {
          this.mapCenter = {lat: this.chargingStations[0].lat, lng: this.chargingStations[0].lng};
        }
        await this.getCpLocsUsage();
      } catch (error) {
        console.error(error)
      }
    },
    async getCpLocsUsage() {
      const res = await this.$axios.get('/cp_locs/map/list-usage');
      const cpLocsUsage = res.data || [];
      const chargingStations = this.chargingStations;
      (chargingStations || []).forEach(station => {
        const matchCpLocUsage = cpLocsUsage.find(cpLoc => cpLoc.locId === station.id);
        if (matchCpLocUsage) {
          station.noOfChargingConnectors = matchCpLocUsage['noOfChargingConnectors'];
          station.noOfAvailableConnectors = matchCpLocUsage['noOfAvailableConnectors'];
          station.noOfUnAvailableConnectors = matchCpLocUsage['noOfUnAvailableConnectors'];
        }
      });
      this.chargingStations = chargingStations;
      this.isLoading = false;
    },
    filterStation(stationId) {
      if (stationId) {
        this.selectedStation = stationId || null;
        const station = this.chargingStations.find(info => info.id === Number(stationId));
        if (station) {
          if (this.map) {
            this.map.setZoom(17);
            this.map.panTo({lat: station.lat, lng: station.lng});
          }
        }
      } else {
        this.resetCenter()
      }
    },
    resetCenter() {
      if (this.map && this.chargingStations && this.chargingStations.length > 0) {
        this.map.setZoom(14);
        this.map.panTo({lat: this.chargingStations[0].lat, lng: this.chargingStations[0].lng});
      }
    },
    fullScreenMap() {
      console.log('fullScreenMap');
      if (this.map) {
        const fullscreenControl = this.map.getDiv().querySelector('button[aria-label="Toggle fullscreen view"]');
        if (fullscreenControl) {
          fullscreenControl.click();
        }
      }
    }
  },
}
</script>
<style lang="scss">
.gm-ui-hover-effect {
  width: 15px !important;
  height: 15px !important;
  margin: 5px !important;

  span {
    margin: 0px !important;
    width: 15px !important;
    height: 15px !important;
  }
}

.main-map {
  padding: 15px;
  display: flex;
  flex-direction: column;

  .vue-map-container {
    height: 100% !important;
  }

  .button-action {
    display: flex;
    flex-direction: row;
    gap: 10px;
  }

  .list-station {
    margin-bottom: 10px;
    width: 250px;
  }

  .bb-div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 10px;

    .cp-loc-name {
      background-color: #ef5350;
      color: white;
      padding: 2px 5px;
      margin-bottom: 5px;
      border-radius: 4px;
      font-weight: bold;
      cursor: pointer;
    }

    .charger-info {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #ef5350;
      color: white;
      font-weight: bold;
      text-align: center;
      border-radius: 50%;
      line-height: 1em;
      vertical-align: middle;
      aspect-ratio: 1 / 1;
      cursor: pointer;
      min-width: 40px;

      div.vld-overlay {
        position: relative;

        div.vld-background {
          background: unset;
        }
      }
    }
  }
}
</style>
